<template>
    <div class="event-list deep-nav__event-list">
    <h4 class="event-list__heading">
      <a :href="item.url">{{ item.label }}</a>
    </h4>
    <ul v-if="item.featuredEvent" class="event-list__list">
      <li class="event-item">
        <a :href="item.featuredEvent.url">
          <time class="event-item__date" :datetime="item.featuredEvent.dateStartUTC">{{ item.featuredEvent.dateStartFormatted }}</time>
          <img class="event-item__image" :src="item.featuredEvent.image.url" :alt="item.featuredEvent.image.title">
          <div class="event-item__wrap">
            <h5 class="event-item__title">{{ item.featuredEvent.title }}</h5>
          </div>
        </a>
      </li>
    </ul>
    <a v-else
      class="event-list__view-all"
      :href="item.url"
    >
      View All
    </a>
  </div>
</template>

<script>
export default {
  name: 'EventList',

  props: {
    item: Object
  }
}
</script>
